import style from "./style.module.scss";
import { Fragment } from "react";

interface props {
    data: { [key: string]: string }
}
function TextPart({ data }: props) {

    return (
        <div className={style.root}>
            <div className={style.content}>
                <div>{data.subTitle || ""}</div>
                <div>{data.title || ""}</div>

                <div className={style.text}>
                    {(() => {
                        if (!(data?.text)) return;
                        const lines = data.text.split("\n");
                        const elements: JSX.Element[] = [];
                        lines.forEach(line => {
                            elements.push(<Fragment key={line}>{line}</Fragment>);
                            elements.push(<br key={line + "br1"} />);
                            elements.push(<br key={line + "br2"} />);
                        });

                        return elements;
                    })()}
                </div>
            </div>
        </div>
    )
}

export default TextPart;